import React, { useState } from 'react';
import { waLink, trackLead } from '../lib/whatsapp';
import { CTA_LABEL, quoteMessage } from '../data/site';
import { ScrollTrigger, useGSAP } from '../lib/gsap';

// Mobile: barra fixa aparece quando o botão do hero sai da tela e some
// quando o formulário final está visível (evita dois botões iguais lado a lado).
const StickyCTA = () => {
  const [pastHero, setPastHero] = useState(false);
  const [atForm, setAtForm] = useState(false);

  useGSAP(() => {
    ScrollTrigger.create({ trigger: '#topo', start: 'bottom 40%', onToggle: (self) => setPastHero(!self.isActive), onEnter: () => setPastHero(true), onLeaveBack: () => setPastHero(false) });
    ScrollTrigger.create({ trigger: '#orcamento', start: 'top bottom', end: 'bottom top', onToggle: (self) => setAtForm(self.isActive) });
  });

  const visible = pastHero && !atForm;

  return (
    <div
      className={`fixed inset-x-0 bottom-0 z-30 border-t border-line bg-page/95 px-4 py-3 backdrop-blur-lg transition-transform duration-300 md:hidden ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
      aria-hidden={!visible}
    >
      <a
        href={waLink(quoteMessage())}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackLead('sticky_mobile')}
        className="flex w-full items-center justify-center rounded-full bg-accent py-3.5 font-semibold text-accent-ink active:scale-[0.98]"
        data-testid="sticky-mobile-cta"
        tabIndex={visible ? 0 : -1}
      >
        {CTA_LABEL}
      </a>
    </div>
  );
};

export default StickyCTA;
